import { ColumnLinks, Link, PromoCard } from '../types';

export const subtitle = 'Learn why customers choose Thrivent';

export const companyLinks: ColumnLinks = {
  title: 'Company',
  links: [
    { text: 'About us', href: 'https://www.thrivent.com/about-us' },
    {
      text: 'Our History',
      href: 'https://www.thrivent.com/about-us/history',
    },
    {
      text: 'Our Leadership',
      href: 'https://www.thrivent.com/about-us/our-leadership',
    },
    {
      text: 'Our Financials',
      href: 'https://www.thrivent.com/about-us/financials',
    },
  ],
};

export const ourValuesLinks: ColumnLinks = {
  title: 'Our Values',
  links: [
    {
      text: 'Our Values',
      href: 'https://www.thrivent.com/about-us/purpose-and-values',
    },
    {
      text: 'Client Stories',
      href: 'https://www.thrivent.com/client-stories',
    },
  ],
};

export const primaryLink: Link = {
  text: 'Why Thrivent',
  href: 'https://www.thrivent.com/why-thrivent',
};

export const promoCard: PromoCard = {
  title: 'How we give back',
  description:
    'Our unique combination of financial services and generosity programs helps you make a difference with your money.',
  callToActionText: 'Learn more',
  callToActionHref: 'https://www.thrivent.com/generosity',
};
